import { useState } from 'react'

import MeasureController from 'core/analytics/MeasureController'

import { GlobalPartnerTable } from './components/globalPartnerTable/GlobalPartnerTable'
import { GlobalPartnerTypeButtons } from './components/globalPartnerTypeButtons/GlobalPartnerTypeButtons'
import { GlobalPartnerTypes } from './models/globalPartnerTypes'
import { TRANSLATION_KEYS } from './translations'

import styles from './GP360Administration.module.scss'

interface IGP360AdministrationProps {
  metrics: MeasureController
}

export const GP360Administration = ({ metrics }: IGP360AdministrationProps) => {
  /** -------------------- Variables ----------------------- */
  const [globalPartnerType, setGlobalPartnerType] = useState(GlobalPartnerTypes.Distributor)

  return (
    <div className={styles.root}>
      <GlobalPartnerTypeButtons
        translationKeyPrefix={TRANSLATION_KEYS.globalPartnerTypeButtonPrefix}
        value={globalPartnerType}
        onOptionClick={setGlobalPartnerType}
      />
      <GlobalPartnerTable globalPartnerType={globalPartnerType} metrics={metrics} />
    </div>
  )
}

export default GP360Administration
